import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit  {
  title = 'app';

  ngOnInit(){
    firebase.initializeApp({
      apiKey: "AIzaSyAD1atXUsU6lrjvueM5dAv5Oa1o6xFGCQk",
      authDomain: "phoneinfo-adfa8.firebaseapp.com",
    });
  }
}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/app.component.ts